(function () {
  if (window.__muralMinimumInitialized) return;
  window.__muralMinimumInitialized = true;

  var MINIMUM_USD_CENTS = 5000;
  var syncing = false;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function currencyRate() {
    var rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    return isFinite(rate) && rate > 0 ? rate : 1;
  }

  function formatPresentmentMoney(usdCents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var locale = document.documentElement.lang ||
      (window.Shopify && window.Shopify.locale) ||
      navigator.language ||
      'en-US';
    var amount = (usdCents * currencyRate()) / 100;
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  function isMarked(properties, key) {
    return String((properties && properties[key]) || '').toLowerCase() === 'yes';
  }

  function baseUnitUsd(item) {
    var properties = item.properties || {};
    var storedMinimumBase = parseInt(properties._minimum_base_price_usd, 10);
    if (isFinite(storedMinimumBase) && storedMinimumBase > 0) return storedMinimumBase;

    // Backward compatibility for mural lines adjusted before custom-size
    // wallpaper was added to the same minimum-order system.
    var storedBase = parseInt(properties._mural_base_price_usd, 10);
    if (isFinite(storedBase) && storedBase > 0) return storedBase;

    var currentUsd = parseInt(properties._custom_price_usd, 10);
    if (isFinite(currentUsd) && currentUsd > 0) return currentUsd;

    return Math.round(((item.final_price || 0) / currencyRate()));
  }

  function minimumOrderLines(cart) {
    return (cart.items || []).filter(function (item) {
      var properties = item.properties || {};
      var isEligible = isMarked(properties, '_is_mural') ||
        isMarked(properties, '_is_custom_wallpaper');
      return isEligible && !isMarked(properties, '_is_sample');
    });
  }

  function minimumNoticeTitle(lines) {
    var hasMural = lines.some(function (item) {
      return isMarked(item.properties || {}, '_is_mural');
    });
    var hasCustomWallpaper = lines.some(function (item) {
      return isMarked(item.properties || {}, '_is_custom_wallpaper');
    });
    if (hasMural && !hasCustomWallpaper) return 'Mural minimum applied';
    if (hasCustomWallpaper && !hasMural) return 'Custom-size minimum applied';
    return 'Custom order minimum applied';
  }

  function setCheckoutBusy(busy) {
    document.querySelectorAll('#checkout, #CartDrawer-Checkout').forEach(function (button) {
      if (busy) {
        if (button.dataset.muralMinimumSyncing !== 'true') {
          button.dataset.muralMinimumPreviouslyDisabled = button.disabled ? 'true' : 'false';
        }
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.dataset.muralMinimumSyncing = 'true';
      } else if (button.dataset.muralMinimumSyncing === 'true') {
        button.disabled = button.dataset.muralMinimumPreviouslyDisabled === 'true';
        button.removeAttribute('aria-disabled');
        delete button.dataset.muralMinimumSyncing;
        delete button.dataset.muralMinimumPreviouslyDisabled;
      }
    });

    document.querySelectorAll('.additional-checkout-buttons, .cart__dynamic-checkout-buttons, .cart__express-divider')
      .forEach(function (element) {
        element.classList.toggle('mural-minimum-syncing', busy);
      });
  }

  function ensureNotice(container) {
    var parent = container.parentElement;
    var notice = parent && parent.querySelector('[data-mural-minimum-notice]');
    if (notice) return notice;

    notice = document.createElement('div');
    notice.className = 'cart-mural-minimum';
    notice.setAttribute('data-mural-minimum-notice', '');
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');
    notice.innerHTML = '<span class="cart-mural-minimum__icon" aria-hidden="true">i</span>' +
      '<span class="cart-mural-minimum__copy"><strong></strong><span></span></span>';
    parent.insertBefore(notice, container);
    return notice;
  }

  function showMinimumNotice(lines, surchargeUsd) {
    document.querySelectorAll('.cart__ctas').forEach(function (container) {
      var notice = ensureNotice(container);
      notice.hidden = surchargeUsd <= 0;
      if (surchargeUsd <= 0) return;

      var title = notice.querySelector('strong');
      var detail = notice.querySelector('.cart-mural-minimum__copy > span');
      title.textContent = minimumNoticeTitle(lines);
      detail.textContent = 'Adjusted to ' + formatPresentmentMoney(MINIMUM_USD_CENTS) +
        ' (+' + formatPresentmentMoney(surchargeUsd) + '). Samples excluded.';
    });
  }

  async function patchLine(item, desiredUnitUsd) {
    var properties = Object.assign({}, item.properties || {});
    var baseUsd = baseUnitUsd(item);
    var desiredPresentment = Math.round(desiredUnitUsd * currencyRate());
    var currentUsd = parseInt(properties._custom_price_usd, 10);
    var currentPresentment = parseInt(properties._custom_price, 10);

    if (currentUsd === desiredUnitUsd && currentPresentment === desiredPresentment &&
      parseInt(properties._minimum_base_price_usd, 10) === baseUsd) return false;

    properties._minimum_base_price_usd = String(baseUsd);
    properties._custom_price_usd = String(desiredUnitUsd);
    properties._custom_price = String(desiredPresentment);

    var response = await fetch(rootUrl() + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: properties }),
    });
    if (!response.ok) throw new Error('Could not apply minimum-order pricing.');
    return true;
  }

  async function refresh() {
    if (syncing) return;
    syncing = true;
    setCheckoutBusy(true);

    try {
      var response = await fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Could not read cart.');
      var cart = await response.json();
      var lines = minimumOrderLines(cart);

      if (!lines.length) {
        showMinimumNotice([], 0);
        setCheckoutBusy(false);
        syncing = false;
        return;
      }

      var baseSubtotalUsd = lines.reduce(function (total, item) {
        return total + (baseUnitUsd(item) * item.quantity);
      }, 0);
      var surchargeUsd = Math.max(0, MINIMUM_USD_CENTS - baseSubtotalUsd);
      showMinimumNotice(lines, surchargeUsd);

      // Put the minimum-order adjustment on one eligible line. Prefer a line
      // with quantity 1 so the adjustment remains exact to the cent.
      var surchargeLine = lines.find(function (item) { return item.quantity === 1; }) || lines[0];
      var changed = false;

      for (var index = 0; index < lines.length; index += 1) {
        var item = lines[index];
        var baseUsd = baseUnitUsd(item);
        var extraPerUnit = item.key === surchargeLine.key
          ? Math.round(surchargeUsd / item.quantity)
          : 0;
        if (await patchLine(item, baseUsd + extraPerUnit)) changed = true;
      }

      if (changed) {
        window.location.reload();
        return;
      }
    } catch (error) {
      console.warn('[custom order minimum] price sync failed:', error);
    }

    setCheckoutBusy(false);
    syncing = false;
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 0); });
  }

  var observer = new MutationObserver(function (mutations) {
    var cartUiChanged = mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes).some(function (node) {
        if (node.nodeType !== 1) return false;
        return node.matches('.cart__ctas, #checkout, #CartDrawer-Checkout') ||
          Boolean(node.querySelector('.cart__ctas, #checkout, #CartDrawer-Checkout'));
      });
    });
    if (cartUiChanged) {
      setCheckoutBusy(syncing);
      setTimeout(refresh, 0);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();
